<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import { mapActions, mapGetters, mapState } from "vuex";
import Swal from "sweetalert2";
import DataTable from "@/components/DataTable.vue";

export default {
  page: {
    title: "Ingredients",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, ModelListSelect, DataTable },

  data() {
    return {
      title: "Ingredients",
      items: [
        { text: "Home", href: "/" },
        { text: "Ingredients", active: true },
      ],
      selected: null,
      totalRows: 1,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      IsRecipesServerPaginated: true,
      serverPerPage: 50,
      filter: null,
      filterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        { key: "index", label: "S/N", sortable: false },
        { key: "product", sortable: true, label: "PRODUCT" },
        { key: "product_qty", label: "PRODUCT QTY", sortable: false },
        { key: "recipe", label: "INGREDIENT" },
        { key: "recipe_qty", label: "INGREDIENT QUANTITY" },
        { key: "unit_cost", label: "UNIT COST" },
        { key: "total_cost", label: "TOTAL COST" },
        { key: "actions", label: "ACTIONS" },
      ],

      filterdata: {
        product: "",
        per_page: 50,
        page: 1,
      },
      editdata: {
        id: "",
        recipe: "",
        product: "",
        product_qty: "",
        recipe_qty: "",
      },
      editProductData: {
        product_id: null,
        product_qty: null,
        productunit: null,
      },
      deletedata: {
        recipe: "",
        product: "",
        id: "",
      },
      basedata: {
        recipe: "",
        product: "",
        product_id: "",
        id: "",
      },
      recipeQtyError: "",
      productQtyError: "",
      editProductQtyError: "",
    };
  },

  computed: {
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("recipes", [
      "SaveStatus",
      "Recipes",
      "RecipesPagination",
      "RecipesPaginated",
    ]),
    ...mapGetters("auth", ["MyUserPerm"]),
    ...mapGetters("products", ["Products"]),

    // rows() {
    //   return this.groupedProductsArray.length;
    // },
    rows() {
      return this.IsRecipesServerPaginated
        ? this.RecipesPagination.total
        : this.RecipesPaginated
        ? this.RecipesPaginated.length
        : 0;
    },

    perPage: {
      get() {
        if (this.IsRecipesServerPaginated) {
          return (
            (this.RecipesPagination && this.RecipesPagination.per_page) ||
            this.filterdata.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsRecipesServerPaginated) {
          this.filterdata.per_page = value;
          this.filterdata.page = 1;
          this.getIngredients(this.filterdata);
        } else {
          this.serverPerPage = value;
        }
      },
    },

    currentPage: {
      get() {
        return this.RecipesPaginated && this.RecipesPagination
          ? this.RecipesPagination.current_page
          : 1;
      },
      set(value) {
        if (this.RecipesPaginated) {
          this.filterdata.page = value;
          this.handlePageChange(value);
        }
      },
    },

    groupedIngredientsByProduct() {
      if (!this.Recipes) return [];

      const grouped = {};
      this.Recipes.forEach((recipe) => {
        const productName = recipe.product;
        if (!grouped[productName]) {
          grouped[productName] = {
            product: productName,
            product_id: recipe.product_id,
            product_qty: recipe.product_qty,
            productunit: recipe.productunit,
            items: [],
          };
        }
        grouped[productName].items.push({
          ...recipe,
        });
      });
      return Object.values(grouped);
    },

    groupedProductsArray() {
      return this.groupedIngredientsByProduct.map((product, index) => ({
        ...product,
        index: index + 1,
      }));
    },

    excelData() {
      const data = [];
      this.groupedIngredientsByProduct.forEach((productGroup) => {
        // Add a row for the product header
        data.push({
          product: productGroup.product,
          product_qty:
            productGroup.product_qty +
            (productGroup.productunit ? " " + productGroup.productunit : ""),
          ingredient: "", // Empty for header row
          recipe_qty: "",
          unit_cost: "",
          total_cost: "",
        });

        // Add rows for each ingredient
        productGroup.items.forEach((item) => {
          data.push({
            product: "", // Empty for ingredient rows
            product_qty: "",
            ingredient: item.recipe,
            recipe_qty:
              item.recipe_qty + (item.recipeunit ? " " + item.recipeunit : ""),
            unit_cost: item.recipe_details.buying_price,
            total_cost: item.recipe_details.buying_price * item.recipe_qty,
          });
        });

        // Add an empty row as a separator
        data.push({});
      });

      return data;
    },

    excelFields() {
      return {
        Product: "product",
        "Product Qty": "product_qty",
        Ingredient: "ingredient",
        "Ingredient Qty": "recipe_qty",
        "Unit Cost": "unit_cost",
        "Total Cost": "total_cost",
      };
    },
  },

  watch: {
    show(newValue) {
      if (newValue) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
    "filterdata.product": {
      handler() {
        this.getIngredients();
      },
      immediate: true,
    },
    Recipes() {
      this.totalRows = this.rows;
    },
  },

  methods: {
    ...mapActions({
      FetchRecipes: "recipes/fetchRecipes",
      FetchItems: "products/fetchProducts",
      DeleteRecipe: "recipes/deleteRecipes",
      EditRecipe: "recipes/editRecipes",
      ChangeBase: "recipes/changeBase",
      EditProductQty: "recipes/editProductQuantity",
    }),

    thousandSeprator(m) {
      if (m !== "" && m !== undefined && m !== null && m !== 0) {
        return m.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return m;
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    closeModal(modalId) {
      this.$bvModal.hide(modalId);
      this.resetData();
      this.resetErrors();
    },
    resetDeleteItem(modalId) {
      this.closeModal(modalId);
      this.deletedata = { recipe: "", product: "", id: "" };
      this.modal_id = "";
    },
    resetEdit(modalId) {
      this.closeModal(modalId);
      this.editdata = {
        id: "",
        recipe: "",
        product: "",
        product_qty: "",
        recipe_qty: "",
      };
      this.modal_id = "";
    },
    resetEditProduct(modalId) {
      this.closeModal(modalId);
      this.editProductData = {
        product_id: null,
        product_qty: null,
        productunit: null,
      };
      this.editProductQtyError = "";
      this.modal_id = "";
    },
    resetErrors() {
      this.recipeQtyError = "";
      this.productQtyError = "";
      this.editProductQtyError = "";
    },
    resetBase() {
      this.basedata = { recipe: "", product: "", product_id: "", id: "" };
      this.modal_id = "";
    },
    resetData() {
      // this.filter = null;
    },

    showEditModal(data) {
      this.editdata = { ...data };
    },
    showEditProductModal(data) {
      this.editProductData.product_id = data.product_id;
      this.editProductData.product_qty = data.product_qty;
      this.editProductData.productunit = data.productunit;
    },
    showDeleteModal(data) {
      this.deletedata = { ...data };
    },
    showBaseModal(data) {
      this.basedata = { ...data };
    },

    editItem(modalId) {
      this.modal_id = modalId;
      if (!this.isValidQuantity(this.editdata.recipe_qty)) {
        this.recipeQtyError = "Ingredient Quantity must be a valid number.";
        return;
      }
      this.recipeQtyError = "";

      if (!this.isValidQuantity(this.editdata.product_qty)) {
        this.productQtyError = "Product Quantity must be a valid number.";
        return;
      }
      this.productQtyError = "";

      this.EditRecipe(this.editdata);
    },
    editProductQuantity(modalId) {
      this.modal_id = modalId;
      if (!this.isValidQuantity(this.editProductData.product_qty)) {
        this.editProductQtyError = "Product Quantity must be a valid number.";
        return;
      }
      this.editProductQtyError = "";

      this.EditProductQty(this.editProductData);
    },

    isValidQuantity(value) {
      return !isNaN(parseFloat(value)) && isFinite(value);
    },

    deleteItem(modalId) {
      this.modal_id = modalId;
      this.DeleteRecipe(this.deletedata);
    },

    changeBase(modalId) {
      this.modal_id = modalId;
      this.basedata.product_id = parseInt(this.basedata.product_id);
      this.ChangeBase(this.basedata);
    },

    getIngredients() {
      this.FetchRecipes(this.filterdata);
    },

    handlePageChange(newPage) {
      if (this.IsRecipesServerPaginated) {
        this.filterdata.page = newPage;
        this.getIngredients(this.filterdata);
      }
    },
  },

  created() {
    this.FetchItems();
    this.getIngredients(this.filterdata);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-7"></div>
              <div class="col-md-5 text end">
                <div class="d-flex align-items-center">
                  <download-excel
                    class="btn btn-info me-2"
                    :data="excelData"
                    :worksheet="'Ingredients'"
                    type="xls"
                    :name="'Ingredients.xls'"
                  >
                    Export <i class="fa fa-download"></i>
                  </download-excel>
                  <div class="mb-4 flex-grow-1">
                    <label>Filter by Product</label>
                    <model-list-select
                      :list="[
                        ...(Products || []),
                        { id: '', name: 'All Products' },
                      ]"
                      v-model="filterdata.product"
                      option-value="id"
                      option-text="name"
                      placeholder="Select Product"
                    >
                    </model-list-select>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:&nbsp;
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search product..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- fields: [
        { key: "index", label: "S/N", sortable: false },
        { key: "product", sortable: true, label: "PRODUCT" },
        { key: "product_qty", label: "PRODUCT QTY", sortable: false },
        { key: "recipe", label: "INGREDIENT" },
        { key: "recipe_qty", label: "INGREDIENT QUANTITY" },
        { key: "unit_cost", label: "UNIT COST" },
        { key: "total_cost", label: "TOTAL COST" },
        { key: "actions", label: "ACTIONS" },
      ], -->

            <!-- Table -->
            <div class="table-responsive mb-0">
              <DataTable
                :columns="fields"
                :rows="groupedProductsArray || []"
                :total-rows="rows"
                :pagination="RecipesPagination"
                :server-pagination="IsRecipesServerPaginated"
                :loading="SaveStatus"
              >
                <!-- Index Column -->
                <template #cell(index)="{ index }">
                  {{ (currentPage - 1) * perPage + index + 1 }}
                </template>

                <template #cell(product)="{ row }">
                  {{ row.product }}
                </template>

                <!-- Product Quantity Column -->
                <template #cell(product_qty)="{ row }">
                  {{ row.product_qty
                  }}{{ row.productunit ? " " + row.productunit : "" }}
                  <b-button
                    v-if="MyUserPerm.edit_products"
                    size="sm"
                    variant="primary"
                    v-b-modal.edit-product-qty-modal
                    class="ml-1"
                    @click="showEditProductModal(row)"
                  >
                    <i class="fa fa-edit"></i>
                  </b-button>
                </template>

                <!-- Ingredient Name Column -->
                <template #cell(recipe)="{ row }">
                  <div v-for="(item, idx) in row.items" :key="idx" class="mb-4">
                    {{ item.recipe }}
                  </div>
                </template>

                <!-- Ingredient Quantity Column -->
                <template #cell(recipe_qty)="{ row }">
                  <div v-for="(item, idx) in row.items" :key="idx" class="mb-4">
                    {{ item.recipe_qty
                    }}{{ item.recipeunit ? " " + item.recipeunit : "" }}
                  </div>
                </template>

                <!-- Unit Cost Column -->
                <template #cell(unit_cost)="{ row }">
                  <div v-for="(item, idx) in row.items" :key="idx" class="mb-4">
                    {{
                      item.recipe_details
                        ? thousandSeprator(item.recipe_details.buying_price)
                        : 0
                    }}
                  </div>
                </template>

                <!-- Total Cost Column -->
                <template #cell(total_cost)="{ row }">
                  <div v-for="(item, idx) in row.items" :key="idx" class="mb-4">
                    {{
                      item.recipe_details
                        ? thousandSeprator(
                            item.recipe_details.buying_price * item.recipe_qty,
                          )
                        : 0
                    }}
                  </div>
                </template>

                <!-- Actions Column -->
                <template #cell(actions)="{ row }">
                  <div v-for="(item, idx) in row.items" :key="idx" class="mb-4">
                    <b-button-group>
                      <b-button
                        v-if="MyUserPerm.edit_products"
                        size="sm"
                        variant="primary"
                        v-b-modal.edit-item-modal
                        @click="showEditModal(item)"
                      >
                        <i class="fa fa-edit"></i>
                      </b-button>
                      <b-button
                        v-if="
                          !item.is_base &&
                          MyUserPerm.delete_products
                        "
                        v-b-modal.delete-item-modal
                        variant="danger"
                        size="sm"
                        @click="showDeleteModal(item)"
                      >
                        <i class="fa fa-trash"></i>
                      </b-button>
                      <b-button
                        size="sm"
                        v-if="!item.is_base"
                        class="bg-soft"
                        v-b-modal.base-ingredient-modal
                        @click="showBaseModal(item)"
                      >
                        <i class="fa fa-cog"></i> Set as Base
                      </b-button>
                    </b-button-group>
                  </div>
                </template>
              </DataTable>

              <!-- modal change default ingredient starts -->
              <b-modal
                header-bg-variant="warning"
                header-text-variant="light"
                body-text-variant="warning"
                footer-bg-variant="warning"
                footer-text-variant="warning"
                id="base-ingredient-modal"
                hide-footer
                @hidden="resetBase()"
              >
                <template #modal-title>
                  Set Ingredient
                  <small
                    ><em>{{ basedata.recipe }}</em></small
                  >
                  as Base Ingredient
                </template>
                <div class="form-group mb-2">
                  <div class="input-group">
                    <h5>
                      Do you want to set Ingredient
                      <small class="text-warning"
                        ><em>{{ basedata.recipe }}</em></small
                      >
                      as Base Ingredient for Product
                      <small class="text-warning"
                        ><em>{{ basedata.product }}</em></small
                      >?
                      <br />
                      This means this ingredient will be considered the default
                      ingredient for this product in recipes. Click Proceed
                      Button to continue.
                    </h5>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                    @click="closeModal('base-ingredient-modal')"
                  >
                    <i class="fa fa-times"></i> Close
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="changeBase('base-ingredient-modal')"
                  >
                    <i class="fa fa-cog"></i> Proceed
                    <b-spinner
                      v-if="SaveStatus"
                      variant="light"
                      small
                      label="Changing"
                    ></b-spinner>
                  </button>
                </div>
              </b-modal>
              <!-- modal ends -->

              <!-- modal edit item starts -->
              <b-modal
                id="edit-item-modal"
                hide-footer
                @hidden="resetEdit()"
                class="text-primary"
              >
                <template #modal-title>
                  Edit Ingredient {{ editdata.recipe }} for product
                  {{ editdata.product }}
                </template>
                <div class="form-group mb-3">
                  <label>Ingredient Quantity</label>
                  <input
                    type="number"
                    class="form-control"
                    step="any"
                    v-model="editdata.recipe_qty"
                  />
                  <div v-if="recipeQtyError" class="text-danger">
                    {{ recipeQtyError }}
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                    @click="closeModal('edit-item-modal')"
                  >
                    <i class="fa fa-times"></i> Close
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="editItem('edit-item-modal')"
                  >
                    <i class="fa fa-check"></i> Save Changes
                    <b-spinner
                      v-if="SaveStatus"
                      variant="light"
                      small
                      label="Deleting"
                    ></b-spinner>
                  </button>
                </div>
              </b-modal>
              <!-- modal ends -->

              <!-- modal edit product quantity starts -->
              <b-modal
                id="edit-product-qty-modal"
                hide-footer
                @hidden="resetEditProduct"
                class="text-primary"
              >
                <template #modal-title> Edit Product Quantity </template>
                <div class="form-group mb-3">
                  <label>Product Quantity</label>
                  <input
                    type="number"
                    class="form-control"
                    step="any"
                    v-model="editProductData.product_qty"
                  />
                  <div v-if="editProductQtyError" class="text-danger">
                    {{ editProductQtyError }}
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                    @click="closeModal('edit-product-qty-modal')"
                  >
                    <i class="fa fa-times"></i> Close
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="editProductQuantity('edit-product-qty-modal')"
                  >
                    <i class="fa fa-check"></i> Save Changes
                    <b-spinner
                      v-if="SaveStatus"
                      variant="light"
                      small
                      label="Updating"
                    ></b-spinner>
                  </button>
                </div>
              </b-modal>
              <!-- modal ends -->

              <!-- modal delete item starts -->
              <b-modal
                id="delete-item-modal"
                hide-footer
                @hidden="resetDeleteItem"
                class="text-danger"
              >
                <template #modal-title>
                  Delete ingredient {{ deletedata.recipe }} for product
                  {{ deletedata.product }}
                </template>
                <div class="form-group mb-3">
                  <div class="input-group">
                    <h5>
                      Do you want to delete this ingredient? Click Proceed to
                      continue.
                    </h5>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                    @click="closeModal('delete-item-modal')"
                  >
                    <i class="fa fa-times"></i> Close
                  </button>
                  <button
                    type="button"
                    class="btn btn-danger"
                    @click="deleteItem('delete-item-modal')"
                  >
                    <i class="fa fa-trash"></i> Proceed
                    <b-spinner
                      v-if="SaveStatus"
                      variant="light"
                      small
                      label="Deleting"
                    ></b-spinner>
                  </button>
                </div>
              </b-modal>
              <!-- modal ends -->

              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  end row -->
  </Layout>
</template>

<style scoped>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}

/* Main table styles */
.main-table {
  width: 100%;
}

.main-table th,
.main-table td {
  vertical-align: top;
  padding: 0.75rem;
}

/* Inner table styles */
.inner-table {
  width: 100%;
  margin-bottom: 0 !important;
  border: none !important;
}

.inner-table th,
.inner-table td {
  padding: 0.5rem !important;
  border-top: none !important;
  vertical-align: middle;
}

.inner-table thead th {
  border-bottom: 1px solid #dee2e6 !important;
}

/* Style for rows in the inner table */
.inner-table-row {
  border-bottom: 1px solid #dee2e6;
}

.inner-table-row:last-child {
  border-bottom: none;
}

.ml-1 {
  margin-left: 0.5rem;
}
</style>
